import { render, staticRenderFns } from "./popmenu.vue?vue&type=template&id=d134f9de&"
import script from "./popmenu.vue?vue&type=script&lang=js&"
export * from "./popmenu.vue?vue&type=script&lang=js&"
import style0 from "./popmenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports